<template>

    <div class="admin-page">
        <Header></Header>
        <section class="admin-section">
            <div class="container">

                <div class="row">
                    <div class="col-md-4">
                        <h1>Artists List</h1>
                    </div>
                    <div class="col-md-4 text-center">
                        <download-csv
                                class   = "download-btn"
                                :data   = "json_data"
                                name    = "userData.csv">

                            Export User Data

                        </download-csv>
                    </div>
                    <div class="col-md-4">
                        <router-link class="next-icon add-btn" to="/admin/artist/create">Add Artist <img src="@/assets/img/next.svg"/></router-link>
                    </div>
                </div>
                <div class="row">
                   <table class="table table-striped">
                       <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Status</th>
                                <th style="width: 250px;">Action</th>
                                <th style="width: 250px;">Complete Profile Mail</th>
                            </tr>
                       </thead>
                       <tbody>
                            <tr v-for="(list) in lists" v-bind:key="list.id">
                                <td>{{list.name}}</td>
                                <td>{{list.email}}</td>
                                <td>{{list.status}}</td>
                                <td><router-link class="edit" :to="`/admin/artist/` + list._id">Edit</router-link> <a href="javascript:void(0)" :data-id="list._id" data-toggle="modal" data-target="#deleteModal" v-on:click="deleteFunction" class="delete">Delete</a> </td>
                                <td>
                                    <a href="javascript:void(0)" :data-id="list._id" :data-email="list.email" v-if="!mailFlag" v-on:click="sendFunction" class="edit">Send</a>
                                </td>
                            </tr>
                       </tbody>
                   </table>
                </div>
            </div>
        </section>
        <Footer :dataId="deleteRecord" :dataModel="model"></Footer>
    </div>
</template>


<script>
    import Header from '../Header'
    import Footer from '../Footer'
    import axios from 'axios'
    import Vue from 'vue'
    import $ from 'jquery'
    import JsonCSV from 'vue-json-csv'
    Vue.component('downloadCsv', JsonCSV)

    export default {
        name: 'ArtistList',
        components: {
            'Header': Header,
            'Footer': Footer
        },
        mounted () {
            axios
                .get('/adminArtists',{
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                })
                .then(response => {
                    console.log(response.data)
                    this.lists = response.data
                    let $this = this
                    $.each(response.data, function (key, val) {
                        if(val.name && val.email){
                            let data = {
                                Name: val.name,
                                Email: val.email,
                                Status: val.status
                            }
                            $this.json_data.push(data)
                        }
                    })
                })
                .catch(error => console.log(error))
        },
        data() {
            var userdata = localStorage.getItem('cbs_admin_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }
            return {
                msg: 'Welcome to Your Vue.js App',
                lists: '',
                mailFlag: false,
                userData: userdata,
                deleteRecord: 'aaaa',
                model: 'Artist',
                json_data: []
            }
        },
        methods: {
            deleteFunction(e) {
                this.deleteRecord = e.target.dataset.id
            },
            sendFunction(event) {
                $(event.target).text('Sending...')
                axios.post('/profileCompleteSend', {
                    email: event.target.dataset.email
                },{
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                }).then(res => {
                    if(res.data){
                        Vue.$toast.open(
                            {
                                message: 'Something went wrong!',
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    } else {
                        Vue.$toast.open(
                            {
                                message: 'Mail Sent!',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    }
                    $(event.target).text('Send')
                }).catch(err => {
                    Vue.$toast.open(
                        {
                            message: 'Something went wrong!',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                    $(event.target).text('Send')
                    console.log(err)
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/artists/List.vue